export default class ChatBotNoApiModel {
  constructor({
    chatBotNoId = 0,
    apiVerboId = 0,
    apiTipoAutorizacaoId = 0,
    apiTipoParametroId = 0,
    apiUrl = '',
    apiUserName = null,
    apiPassword = null,
    apiBearerToken = null,
    apiParametroJsonBody = null,
    apiResponseProperty = null,
    parametros = [],
  } = {}) {
    this.chatBotNoId = chatBotNoId
    this.apiVerboId = apiVerboId
    this.apiTipoAutorizacaoId = apiTipoAutorizacaoId
    this.apiTipoParametroId = apiTipoParametroId
    this.apiUrl = apiUrl
    this.apiUserName = apiUserName
    this.apiPassword = apiPassword
    this.apiBearerToken = apiBearerToken
    this.apiParametroJsonBody = apiParametroJsonBody
    this.apiResponseProperty = apiResponseProperty
    this.parametros = parametros
  }
}
